export const log = {
  info: (data: any) => {
    // eslint-disable-next-line no-console
    console.log(JSON.stringify(data));
  },
  error: (data: any) => {
    // eslint-disable-next-line no-console
    console.log(JSON.stringify(data));
  },
  warn: (data: any) => {
    // eslint-disable-next-line no-console
    console.log(JSON.stringify(data));
  },
  debug: (data: any) => {
    // eslint-disable-next-line no-console
    console.log(JSON.stringify(data));
  },
};
